import { Button } from "react-bootstrap";

const GoalTrackButton = ({ element, selected, onClick, disabled, color }) => {
  return (
    <div
      className="goal-track d-flex align-items-center justify-content-center rounded-circle themeBlue"
      // style={{ backgroundColor: selected ? "#ac5c9a" : "#fff" }}
      style={{
        height: "30px",
        width: "30px",
        border: selected ? `3px solid ${color}` : "0.5px solid #00000073",
        background: "#fff",
      }}
    >
      <Button className={`fw-bold`} style={{ border: "none", opacity: "1", fontSize: "14px" }} variant="transparent" onClick={onClick} disabled={selected || disabled}>
        {element}
      </Button>
    </div >
  );
}

export default GoalTrackButton;